<template>
    <div>
        <div class="filters">
          <el-row :gutter="20">
            <el-col :span="8">
              <span class="t-label">{{$t('project_select_clients')}}</span>
              <el-select
                  style="width:100%"
                  class="inputs"
                  no-data-text="no data"
                  v-model="filterClientId"
                  :label="$t('project_select_clients')"
                  :placeholder="$t('project_select_clients')"
                  size="mini">
                <el-option
                    v-for="item in clientList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="setFilter(item.id, filterRegionId, filterStageId)">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="t-label">{{$t('project_select_region')}}</span>
              <el-select
                  style="width:100%"
                  class="inputs"
                  no-data-text="no data"
                  v-model="filterRegionId"
                  :label="$t('project_select_region')"
                  :placeholder="$t('project_select_region')"
                  size="mini">
                <el-option
                    v-for="item in regions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="setFilter(filterClientId, item.id, filterStageId)">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="t-label">{{$t('project_select_stages')}}</span>
              <el-select
                  style="width:100%"
                  class="inputs"
                  no-data-text="no data"
                  v-model="filterStageId"
                  :label="$t('project_select_stages')"
                  :placeholder="$t('project_select_stages')"
                  size="mini">
                <el-option
                    v-for="item in stages"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="setFilter(filterClientId, filterRegionId, item.id)">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <el-table
                :data="businessUnitProjectsList"
                border
                style="width: 100%">
            <el-table-column
                    prop="no"
                    :label="$t('bu_tab_info_no')"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="name"
                    :label="$t('bu_tab_info_name')">
            </el-table-column>
            <el-table-column
                    :label="$t('bu_tab_info_owner')"
                    width="80"
                    align="center"
                    header-align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.owner"
                               size="mini"
                               type="success"
                               circle></el-button>
                </template>
            </el-table-column>
            <el-table-column
                    width="200"
                    :label="$t('bu_tab_info_action')">
                <template slot-scope="scope">
                    <el-button size="mini" @click="$router.push(`/projects?companyId=${scope.row.company_id}&projectId=${scope.row.id}&taskId=0`)" >{{$t('bu_tab_info_select')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    import moment from 'moment'
    import axios from "axios";
    export default {
        computed: {
            businessUnitProjectsList() {
                return this.$store.state.businessUnitProjectsList
            },
        },
        name: "BusinessUnitProjects",
      data(){
          return {
            moment:moment,
            clientList: [],
            regions: [],
            stages: [],
            filterClientId: 0,
            filterRegionId: 0,
            filterStageId: 0
          }
      },
      mounted() {
        this.getClientsList()
        this.getRegions()
        this.getProjectStages()
      },
      methods: {
        ...mapMutations({
          getBusinessUnitProjectsList: 'getBusinessUnitProjectsList'
        }),
        setFilter(clientId, regionId, stageId) {
            console.log('clientId, regionId, stageId', clientId, regionId, stageId)
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .get(`/api/v1/businessUnits/projectsListBU?businessUnitId=${this.$route.query.businessUnitId || null}`)
                .then(response => {
                  let list = response.data.list
                  // filter list
                  if (clientId) {
                    // TODO filter clients
                    list = list.filter(val => val.projectClient.some(val => val.companyClientId === clientId))
                  }
                  if (regionId) {
                    list = list.filter(val => val.projectRegionId === regionId)
                  }
                  if (stageId) {
                    list = list.filter(val => val.companyStageId === stageId)
                  }
                  this.getBusinessUnitProjectsList(list)
                  console.log('list', list)
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
        },
        getClientsList() {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/companyClients/list?companyId=${this.$route.query.companyId}`)
              .then(response => {
                this.clientList = response.data.list
                this.clientList.unshift({name: 'All', id: 0})
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        },
        getRegions() {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/regions/list?companyId=${this.$route.query.companyId}&type=project`)
              .then(response => {
                console.log('---', response.data);
                this.regions = response.data.list;
                this.regions.unshift({name: 'All', id: 0});
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        },
        getProjectStages() {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`api/v1/companyStages/listFilter?companyId=${this.$route.query.companyId}&entityType=1`)
              .then(response => {
                console.log('---', response.data);
                this.stages = response.data.list
                this.stages.unshift({name: 'All', id: 0})
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }
      }
    }
</script>

<style lang="scss" scoped>
  .filters {
    margin-bottom:20px;
    .t-label {
      font-size: 14px;
    }
  }
</style>
